import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import SEOHead from '../components/SEOHead';
import PathwayDisclaimer from '../components/PathwayDisclaimer';
import data from '../data/pathway15states.json';
import { SourceDrawer, useDrawer } from '../components/pathway15/SourceDrawer';
import { StagesIntro } from '../components/pathway15/StagesIntro';
import { StatePlan, STATES, DEFAULT_STATE } from '../components/pathway15/StatePlan';
import { PracticeRoutes, DiscoveryProposal } from '../components/pathway15/PracticeRoutes';
import { EvidenceCompact } from '../components/pathway15/EvidenceCompact';

export default function TheAIShift() {
  const [stateId, setStateId] = useState(DEFAULT_STATE);
  const stateName = STATES.find((s) => s.id === stateId)?.name || '';
  const { drawer, open, close } = useDrawer();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-amber-50 overflow-x-hidden">
      <SEOHead title="The AI Shift · Prepare Now · AI → AGI → ASI" description={data.page_copy.intro} path={data.pathway.route || '/the-ai-shift'} image="/images/the-ai-shift-cover.webp" />
      <Navbar />
      <main className="pt-24 md:pt-28 pb-16 px-4 min-w-0">
        <div className="max-w-5xl mx-auto space-y-10 min-w-0">
          <StagesIntro />
          <StatePlan stateId={stateId} setStateId={setStateId} openDrawer={open} />
          <PracticeRoutes stateId={stateId} stateName={stateName} openDrawer={open} />
          <DiscoveryProposal />
          <EvidenceCompact openDrawer={open} />
          <p className="text-xs text-gray-500" data-testid="p15-footer-note">{data.practical_education.shared_framework.status} PLFS figures: {data.statistics.reference_period} survey period · Sources reviewed 19 September 2026 (review date, not an observation date). Contact <a href={`mailto:${data.practical_education.shared_framework.contact}`} className="underline text-teal-700">{data.practical_education.shared_framework.contact}</a>.</p>
        </div>
      </main>
      <PathwayDisclaimer />
      <SourceDrawer open={!!drawer} onOpenChange={(o) => !o && close()} title={drawer?.title || ''} description={drawer?.description} sourceIds={drawer?.sourceIds || []}>
        {drawer?.body && <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">{drawer.body.map((b) => <li key={b}>{b}</li>)}</ul>}
        {drawer?.node}
      </SourceDrawer>
    </div>
  );
}
